<template>
    <main class="settings">
        <div class="container">
            <h1>Instellingen</h1>
            <form class="card" @submit.prevent="handleSubmit">
                <div class="card-body">
                    <div class="row align-items-center">
                        <div class="col-md-8 text-md-right">
                            <label for="settingsWallpaper"
                                >Achtergrondafbeelding</label
                            >
                        </div>
                        <div class="col-md-16">
                            <RockWallpaperSelection
                                v-model="selectedWallpaper"
                            />
                        </div>
                    </div>
                    <div v-if="dirty" class="row mt-4 align-items-center">
                        <div class="col-md-auto offset-md-8">
                            <button
                                class="btn btn-secondary no-arrow"
                                type="submit"
                            >
                                Wijzigingen opslaan
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </main>
</template>

<script>
import EventBus from '@/shared/VueEvent';
import RockWallpaperSelection from '@/components/RockWallpaperSelection.vue';
import {
    getWallpaperFromStorage,
    setWallpaperInStorage,
    getWallpaperFromId
} from '@/constants/wallpapers';

export default {
    name: 'RockSettings',

    components: {
        RockWallpaperSelection
    },

    data: () => ({
        dirty: false,
        originalWallpaper: { ...getWallpaperFromStorage },
        selectedWallpaper: { ...getWallpaperFromStorage }
    }),

    watch: {
        selectedWallpaper(newWallpaper) {
            this.dirty =
                !this.originalWallpaper ||
                newWallpaper.id !== this.originalWallpaper.id;
            EventBus.fire('changeBackgroundImage', newWallpaper);
        }
    },
    created() {
        this.getSettings();
    },

    methods: {
        handleSubmit() {
            this.putSettings(this.selectedWallpaper);
            EventBus.fire('saveBackgroundImage', this.selectedWallpaper);
        },

        putSettings(wallpaper) {
            const self = this;
            self.$http
                .put('/settings', {
                    wallpaper: wallpaper.id
                })
                .then(() => {
                    setWallpaperInStorage(wallpaper);
                    self.dirty = false;
                    self.originalWallpaper = { ...wallpaper };
                });
        },

        getSettings() {
            const self = this;
            self.$http.get('/settings').then(({ data }) => {
                const wallpaper = getWallpaperFromId(
                    data.wallpaper.toUpperCase()
                );
                self.originalWallpaper = { ...wallpaper };
                self.selectedWallpaper = { ...wallpaper };
            });
        }
    }
};
</script>
